var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#2cc47f",
    r: 256
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-10.504-.633-20.861-1.862-31.033l-75.138-75.138-358 227.269 130.27 130.27c15.775 3.04 32.067 4.632 48.73 4.632 141.385 0 256-114.615 256-256z",
    fill: "#06b26b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m108.344 135.987h295.778l3.984 252.265h-304.212l-13.713-218.932z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.122 135.987h-148.122v252.265h152.107l2.001-211.601z",
    fill: "#e9edf5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408.106 388.252v-209.876c0-1.627-.888-3.15-2.337-3.891-1.545-.79-3.045-.677-4.455.338l-145.314 121.996-145.314-121.996c-1.409-1.015-2.909-1.128-4.455-.338-1.449.74-2.337 2.263-2.337 3.89v209.878c-20.987 0-38-17.013-38-38v-171.95c0-15.944 8.815-30.365 23.005-37.635 14.191-7.27 31.044-6.001 43.985 3.313l123.116 106.019 123.116-106.019c13.088-9.42 30.179-10.611 44.467-3.062 14.032 7.413 22.523 22.281 22.523 38.151v171.183c0 20.986-17.013 37.999-38 37.999z",
    fill: "#ff583e"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.584 140.919c-14.288-7.548-31.379-6.357-44.467 3.062l-123.117 105.915v46.821l145.314-121.894c1.41-1.015 2.91-1.128 4.455-.338 1.449.741 2.337 2.263 2.337 3.891v209.876c20.987 0 38-17.013 38-38v-171.182c0-15.87-8.491-30.738-22.522-38.151z",
    fill: "#f92814"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9c591914767bc2d91810d0592543c79d.svg";
export { ForwardRef as ReactComponent };